/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

const es_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} PPP`)
};

const de_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

const nl_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

const fr_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} PPP`)
};

const it_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

const pt_br2_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

const pt_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

const ja_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

const zh_ruler_dpi = /** @type {(inputs: { dpi: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.dpi} DPI`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ dpi: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_dpi = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_dpi(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_dpi", locale)
	if (locale === "en") return en_ruler_dpi(inputs)
	if (locale === "es") return es_ruler_dpi(inputs)
	if (locale === "de") return de_ruler_dpi(inputs)
	if (locale === "nl") return nl_ruler_dpi(inputs)
	if (locale === "fr") return fr_ruler_dpi(inputs)
	if (locale === "it") return it_ruler_dpi(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_dpi(inputs)
	if (locale === "pt") return pt_ruler_dpi(inputs)
	if (locale === "ja") return ja_ruler_dpi(inputs)
	return zh_ruler_dpi(inputs)
};